import App from './App.svelte';

const app = new App({
	target: document.body,
	props: {
		image: 'https://d1fdloi71mui9q.cloudfront.net/QFTgIiZxTy27dbU7fqq7_66478wOaQM3gkkBD',
		title: 'Sweet Emotion',
		subtitle: 'Brigadeiros | Trufas | Bombones',
		buttons: [
			{
				title: 'Carta Online',
				link: 'https://google.com.uy'
			},
			{
				title: 'WhatsApp',
				link: 'https://google.com.uy'
			},
			{
				title: 'Telegram',
				link: 'https://google.com.uy'
			},
			{
				title: 'Realiza tu pedido',
				link: 'https://google.com.uy'
			},
		],
	}
});

export default app;